/**
 * Titulo legivel do papel RBAC (`users.role`), para exibir em tela.
 *
 * ⚠️ **Espelha `ROLE_DEFINITIONS` do `cinco-back`** (`src/modules/users/rbac/
 * rolePermissions.ts`), que e a fonte de verdade. Ao mexer nos papeis la, mexa
 * aqui — sao os perfis de `docs/roles/Roles.pdf`.
 *
 * Por que um mapa local, e nao `GET /roles`: aquela rota exige `list_profiles`,
 * chave que o **Leitor nao tem** — e o Leitor abre a listagem de usuarios. Buscar
 * o titulo da API deixaria a coluna vazia justamente para ele.
 *
 * Valor desconhecido volta como veio: melhor mostrar o slug do que celula vazia,
 * que parece dado que nao carregou.
 */
const USER_ROLE_TITLES: Record<string, string> = {
  administrator: 'Administrador',
  coordinator: 'Coordenador',
  clerk: 'Atendente',
  reader: 'Leitor',
  patient: 'Paciente',
};

const getUserRoleTitle = (role?: string): string | undefined =>
  role ? USER_ROLE_TITLES[role] ?? role : undefined;

export default getUserRoleTitle;
